import { setError } from '../../store/actions/error';
import { type ApiResult, type ErrorResponse, type PaginatedResult } from '../common/structs';

import { apiFactory } from './api';

export function apiReturnResults<T, ET = ErrorResponse>(
    apiCall,
    params,
    publicRequest = false,
): Promise<ApiResult<T, ET>> {
    return apiFactory()
        .call(apiCall, params, { publicRequest })
        .then((r) => {
            return r;
        })
        .catch((e) => e) as unknown as Promise<ApiResult<T, ET>>;
}

export function apiReturnPaginatedResults<T, P = PaginatedResult<T>>(
    apiCall,
    params,
    publicRequest = false,
): Promise<P> {
    return apiFactory()
        .call(apiCall, params, { publicRequest })
        .then((r) => {
            if (r?.ok) {
                return r.value;
            }
        })
        .catch((e) => {
            setError({
                ...e,
                log: false,
            });
            return e;
        }) as unknown as Promise<P>;
}
